import React, { useEffect, useState, useCallback } from 'react'
import MarketInfo from '../components/marketPlace/MarketInfo'
import { MarketContext } from '../components/marketPlace/MarketContext'
import { getPassport, getProfile, buyItem } from '../api'
import '../index.css'

const EMPTY_OWNED = { profile: new Set(), background: new Set(), badge: new Set(), font: new Set(), rank: new Set() }

const Marketplace = () => {
  const [state, setState] = useState({
    loggedIn: false,
    loading: true,
    balance: 0,
    owned: EMPTY_OWNED,
    equipped: {},
  })

  useEffect(() => {
    (async () => {
      try {
        const pass = await getPassport()
        if (!pass || !pass.user || pass.user.id === 'NOPASS') {
          setState(s => ({ ...s, loading: false }))
          return
        }
        const data = await getProfile(pass.user.id)
        if (!data || data.error) {
          setState(s => ({ ...s, loading: false }))
          return
        }
        setState({
          loggedIn: true,
          loading: false,
          balance: data.balancerp || 0,
          owned: {
            profile: new Set(data.profile || []),
            background: new Set(data.banner || []),
            badge: new Set(data.badges || []),
            font: new Set(data.font || []),
            rank: new Set(data.rankimages || []),
          },
          equipped: {
            profile: data.curprofile,
            background: data.curprofilebg,
            badge: new Set(data.curbadges || []),
            font: data.curFont,
            rank: data.currankimg,
          },
        })
      } catch (err) {
        console.error(err)
        setState(s => ({ ...s, loading: false }))
      }
    })()
  }, [])

  const buy = useCallback(async (category, tag) => {
    const result = await buyItem(category, tag)
    if (result && result.ok) {
      setState(s => {
        const owned = { ...s.owned, [category]: new Set([...s.owned[category], tag]) }
        return { ...s, owned, balance: result.balance ?? s.balance }
      })
    }
    return result
  }, [])

  return (
    <MarketContext.Provider value={{ ...state, buy }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="text-center mb-10">
          <h1 className="font-Bebas display-section text-white mb-3">
            THE <span className="text-gradient">MARKETPLACE</span>
          </h1>
          <p className="font-poppins text-white/50 text-sm sm:text-base max-w-xl mx-auto">
            Spend your hard-earned RP on profile cards, backgrounds and badges.
          </p>
          {state.loggedIn && (
            <p className="font-poppins text-sm mt-4 inline-block glass px-5 py-2">
              <span className="text-white/50">Your balance:</span>{' '}
              <span className="text-amber-300 font-semibold">{state.balance.toLocaleString()} RP</span>
            </p>
          )}
          {!state.loggedIn && !state.loading && (
            <p className="font-poppins text-sm mt-4">
              <a href="/auth/discord" className="text-reored hover:text-red-400 transition-colors">
                Login with Discord
              </a>{' '}
              <span className="text-white/40">to buy items and see what you own.</span>
            </p>
          )}
        </div>
        <MarketInfo />
      </div>
    </MarketContext.Provider>
  )
}

export default Marketplace
